/** 0 € es un honorario válido. Ausente = null/undefined/NaN/negativo. */
export function isPresentFeeCents(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}

export function parseFeeCents(value: unknown): number | null {
  if (typeof value === 'number') {
    return isPresentFeeCents(value) ? Math.round(value) : null;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return isPresentFeeCents(n) ? Math.round(n) : null;
  }
  return null;
}

export const FALLBACK_FISHING_HONORARIO_CENTS = 1990;

/** Receta override → catálogo → fallback. Misma jerarquía que Functions. */
export function resolveHonorarioCents(opts: {
  recipeFeeCents?: unknown;
  catalogFeeCents?: unknown;
  fallbackCents?: number;
}): number {
  const recipe = parseFeeCents(opts.recipeFeeCents ?? null);
  if (recipe !== null) return recipe;
  const catalog = parseFeeCents(opts.catalogFeeCents ?? null);
  if (catalog !== null) return catalog;
  return opts.fallbackCents ?? FALLBACK_FISHING_HONORARIO_CENTS;
}

export function fmtHonorarioEur(cents: number): string {
  return (
    (cents / 100).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + '\u00a0€'
  );
}
